import React from 'react';

import { withBasePath } from '@/hooks/useAppRouter';
import { Link } from '@/navigation';

export interface AppLinkProps {
  href: string;
  children: React.ReactNode;
  [key: string]: any;
}

const AppLink: React.FC<AppLinkProps> = ({ href, children, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Link href={withBasePath(href)} {...props}>
    {children}
  </Link>
);

export default AppLink;
